var _a;
import GoodList from '../page/good/List.vue';
import Company from '../page/Company.vue';
import supplierOrganList from '../page/supplierorgan/List.vue';
import Purchaseorder from '../page/purchaseorder/List.vue';
import Supplier from '../page/supplier/List.vue';
import Client from '../page/client/List.vue';
import Message from '../page/Message.vue';
import ExportDownload from '../page/common/ExportDownload.vue';
import PurInList from '../page/purchasein/List.vue';
import PurBackList from '../page/purchaseback/List.vue';
import User from '../page/user/List.vue';
import LicenseList from '../page/licenseManage/LicenseList.vue';
import DeliverList from '../page/deliver/List.vue';
import EntrustedDeliveryList from '../page/entrustedDelivery/List.vue';
import MemberBalanceManageList from '../page/memberBalanceManage/List.vue';
import RechargeManageList from '../page/rechargeManage/List.vue';
import PowerAuthManageList from '../page/powerAuthManage/List.vue';
import GroupList from '../page/clientGroup/List.vue';
import Payment from '../page/payment/Payment.vue';
import AccountCheck from '../page/accountcheck/Index.vue';
import UpperPayment from '../page/upperPayment/PaymentOrder.vue';
import PayCert from '../page/payCert/List.vue';
import QuotedPrice from '../page/quotedprice/List.vue';
import PricesStting from '../page/pricesetting/List.vue';
import GoodCategory from '../page/goodcategory/GoodCategory.vue';
import { idDict } from '../constant/authCode';
import PrintConfig from '../page/printconfig/List.vue';
import PurSorting from '../page/purchasesorting/List.vue';
import ReportStock from '../page/reportstock/QueryList.vue';
import ReportStockDetail from '../page/reportstock/QueryDetailList.vue';
import ReportStockSummary from '../page/reportstock/QuerySummaryList.vue';
import StoreArchives from '../page/basicArchives/StoreArchives.vue';
import PurchasePrice from '../page/basicArchives/PurchasePrice.vue';
import PurchaseList from '../page/purchase/List.vue';
import PlanOrderForUpperSupList from '../page/planOrderForUpperSup/List.vue';
import PurchaseOrderForUpperSupList from '../page/purchaseOrderForUpperSup/List.vue';
import PurchaseRefundForUpperSupList from '../page/purchaseRefundForUpperSup/List.vue';
import WarehouseList from '../page/warehouse/List.vue';
import TakeStockList from '../page/takeStock/List.vue';
import StockInitList from '../page/stockInit/List.vue';
import IncomeOrderList from '../page/incomeorder/List.vue';
import SalesSummaryReportList from '../page/salesReport/SalesSummaryReportList.vue';
import SalesDetailList from '../page/salesReport/SalesDetailList.vue';
import ThirdPartySystemList from '../page/thirdPartySystem/List.vue';
import SystemSettings from '../page/systemSettings/Index.vue';
import SortingSettings from '../page/sortingSettings/Index.vue';
import ThirdPartyPaymentList from '../page/systemSettings/List.vue';
import OrderImportTemplate from '../page/orderImportTemplate/List.vue';
import PurchaseReportDetailForUpperSup from '../page/purchaseReportForUpperSup/DetailList.vue';
import purchaseReportSummaryForUpperSup from '../page/purchaseReportForUpperSup/SummaryList.vue';
import WarningRuleList from '../page/warningRule/List.vue';
import RejectStockInOrder from '../page/rejectStockInOrder/List.vue';
import ApplicationOrder from '../page/applicationOrder/List.vue';
import ApplicationOrderType from '../page/applicationOrderType/List.vue';
import OperationReport from '../page/operationReport/List.vue';
import LossAnasyle from "../page/operationReport/LossAnasyle.vue";
import PriceAnalyze from '../page/priceAnalyze/List.vue';
import SalePriceAnalyze from '../page/salePriceAnalyze/List.vue';
import ShoppingManageList from '../page/shopping/ManageList.vue';
import ShopActivityList from '../page/shopActivityList/List.vue';
import ShopActivityPoster from "../page/shopActivityPoster/List.vue";
import ShopAfterSalesList from '../page/shopAfterSales/List.vue';
import shopNewDemandList from '../page/shopNewDemand/List.vue';
import BusinessGoodsPriceList from '../page/businessgoodsprice/List.vue';
import UpperSupCheck from '../page/uppersupcheck/Index.vue';
import OnlinePay from "../page/payCert/OnlinePayV2.vue";
import triumphSummary from "../page/triumphReport/summary.vue";
import triumphDetail from "../page/triumphReport/detail.vue";
import CustomerStockList from "../page/salesReport/customerStockList.vue";
import OperateRecord from "../page/operateRecord/Index.vue";
import ServiceInterface from "../page/serviceInterface/Index.vue";
var moduleDic = (_a = {},
    _a[idDict['8001']] = GoodList,
    _a[idDict['6001']] = Company,
    _a[idDict['6009']] = supplierOrganList,
    _a[idDict['9001']] = Purchaseorder,
    _a[idDict['6006']] = Supplier,
    _a[idDict['11001']] = Client,
    _a[idDict['1400000']] = Message,
    _a[idDict['9002']] = PurInList,
    _a[idDict['9003']] = PurBackList,
    _a[idDict['9004']] = RejectStockInOrder,
    _a[idDict['6003']] = User,
    _a[idDict['6002']] = LicenseList,
    _a[idDict['10001']] = DeliverList,
    _a[idDict['10002']] = EntrustedDeliveryList,
    _a[idDict['11002']] = GroupList,
    _a[idDict['12002']] = Payment,
    _a[idDict['12001']] = AccountCheck,
    _a[idDict['12003']] = UpperSupCheck,
    _a[idDict['12004']] = UpperPayment,
    _a[idDict['12005']] = PayCert,
    _a[idDict['12006']] = ApplicationOrder,
    _a[idDict['12007']] = ApplicationOrderType,
    _a[idDict['12008']] = MemberBalanceManageList,
    _a[idDict['12009']] = RechargeManageList,
    _a[idDict['6010']] = PowerAuthManageList,
    _a[idDict['12010']] = OnlinePay,
    _a[idDict['13001']] = QuotedPrice,
    _a[idDict['13002']] = PricesStting,
    _a[idDict['8002']] = GoodCategory,
    _a[idDict['16001']] = PrintConfig,
    _a[idDict['6007']] = BusinessGoodsPriceList,
    _a[idDict['18001']] = PurSorting,
    _a[idDict['210001']] = ReportStock,
    _a[idDict['210002']] = ReportStockDetail,
    _a[idDict['210003']] = ReportStockSummary,
    _a[idDict['210008']] = OperationReport,
    _a[idDict['210009']] = LossAnasyle,
    _a[idDict['210010']] = PriceAnalyze,
    _a[idDict['210011']] = SalePriceAnalyze,
    _a[idDict['6004']] = StoreArchives,
    _a[idDict['6005']] = PurchasePrice,
    _a[idDict['190002']] = PlanOrderForUpperSupList,
    _a[idDict['190003']] = PurchaseOrderForUpperSupList,
    _a[idDict['190001']] = PurchaseList,
    _a[idDict['190004']] = PurchaseRefundForUpperSupList,
    _a[idDict['200001']] = WarehouseList,
    _a[idDict['200002']] = TakeStockList,
    _a[idDict['200003']] = IncomeOrderList,
    _a[idDict['200004']] = StockInitList,
    _a[idDict['200005']] = WarningRuleList,
    _a[idDict['210005']] = SalesSummaryReportList,
    _a[idDict['210004']] = SalesDetailList,
    _a[idDict['210006']] = PurchaseReportDetailForUpperSup,
    _a[idDict['210007']] = purchaseReportSummaryForUpperSup,
    _a[idDict['6008']] = ThirdPartySystemList,
    _a[idDict['16002']] = SystemSettings,
    _a[idDict['16003']] = ThirdPartyPaymentList,
    _a[idDict['16004']] = OrderImportTemplate,
    _a[idDict['16005']] = SortingSettings,
    _a[idDict['16007']] = ServiceInterface,
    _a[idDict['310001']] = ShoppingManageList,
    _a[idDict['310002']] = ShopAfterSalesList,
    _a[idDict['310003']] = shopNewDemandList,
    _a[idDict['210013']] = triumphSummary,
    _a[idDict['210014']] = triumphDetail,
    _a[idDict['210012']] = CustomerStockList,
    _a[idDict['310004']] = ShopActivityList,
    _a[idDict['310005']] = ShopActivityPoster,
    _a[idDict['16006']] = OperateRecord,
    _a[idDict['5008']] = ExportDownload,
    _a[idDict['12011']] = 'Invoice',
    _a);
export default moduleDic;
